import React from "react";
import Spinner from "../utility/spinner";
import QuestionBox from "../utility/question-box";
import * as notificationAction from "../../actions/notification-action";
import rq from "../utility/rq.js";

export default class Permission extends React.Component {
    constructor() {
        super();
        this.state = {
            spinner: true,
            fields: [],
            records: {
                actualRow: [],
                permissionRows: []
            }
        };

        this.questionBox = null;
        this.myData = null;
    }

    getData(rowId, tableName) {
        rq.getJsonData(`/api/v1/getpermissiondata/${tableName}-${rowId}`).then((data) => {
            if (data.permissionRows.length > 0) {
                switch (data.permissionRows[0].permission) {
                    case 1: {                                // delete block                    
                        this.myData = data;
                        this.setState({ fields: Object.keys(data.actualRow[0]), spinner: false, records: data });
                        break;
                    }
                    case 2: {                                       // edite block
                        if (data.permissionRows.length > 0) {
                            this.myData = data;
                            this.setState({ fields: Object.keys(JSON.parse(data.permissionRows[0].reportData)), spinner: false, records: data });
                        }
                        break;
                    }
                    case 3: {                            //insert or create block
                        this.myData = data;
                        this.setState({ spinner: false, records: data });
                        break;
                    }
                    default: {
                        break;
                    }
                }

            }
        }).catch((err) => {
            alert("faild get data ");
        });
    }
    componentWillMount() {
        //console.log("component will mount");
        this.getData(this.props.params.rowId, this.props.params.tableName);

    }
    componentWillReceiveProps(nextProps) {
        this.getData(nextProps.params.rowId, nextProps.params.tableName);
    }

    askQuestion(msg, yesCallBack, noCallBack) {
        this.questionBox = <QuestionBox questionMsg={msg} yesCallBack={yesCallBack} noCallBack={noCallBack}></QuestionBox>;
        this.setState(this.state);
    }
    onAccept(permissionData) {
        this.askQuestion("Do you want to accept it ?", () => {
            this.questionBox = null;
            this.setState({ spinner: true });
            rq.post("/api/v1/acceptpermission", permissionData).then(() => {
                this.questionBox = null;
                this.setState({ spinner: false, records: { permissionRows: [] } });

                // making ajax call to notification to updata notification number
                notificationAction.getAllNotification();

            }).catch(() => {
                alert("accept failed");
            });

        }, () => {
            this.questionBox = null;
            this.forceUpdate();
        });
    }

    onReject(notificationId) {
        this.askQuestion("Do you want to reject it ?", () => {
            this.setState({ spinner: true });
            rq.post("/api/v1/rejectpermission", { notificationId: notificationId }).then(() => {
                this.questionBox = null;
                this.setState({ spinner: false, records: { permissionRows: [] } });

                // making ajax call to notification to updata notification 
                notificationAction.getAllNotification();
            }).catch(() => {

            });

        }, () => {
            this.questionBox = null;
            this.forceUpdate();
        });
    }

    render() {

        let reportData = this.state.records.permissionRows.length > 0 ? JSON.parse(this.state.records.permissionRows[0].reportData) : null;

        return (
            <div>
                {
                    this.myData ? <div className="normalPage">
                        {this.state.spinner ? <Spinner></Spinner> : null}
                        {this.questionBox}

                        <h2 style={{ textAlign: "center", fontSize: "1.5em", color: "#969696", textTransform: "lowercase" }}>{this.state.records.length > 0 ? this.state.records.permissionRows[0].msg : null}</h2>

                        <br />
                        <br />
                        <br />
                        {/*...................Edit block....................*/}
                        {this.state.records.permissionRows.length > 0 && this.state.records.permissionRows[0].permission === 2 ?
                            <div>
                                <p style={{ marginBottom: "5px", color: "#0069ff", fontSize: "1.1em" }}>Current Data:</p>
                                <table className="simple">
                                    <thead>
                                        <tr>
                                            {this.state.fields.map((column, i) => {
                                                return (<th key={i}>{column.replace(/([A-Z])/g, " $1").replace(/^./, function (str) { return str.toUpperCase(); })}</th>);
                                            })}
                                            <th>Time Stamp</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            {this.state.fields.map((field, i) => {
                                                console.log(field, this.state.records.actualRow[0][field] === reportData[field]);
                                                console.log(field, this.state.records.actualRow[0][field]);
                                                console.log(field, reportData[field]);
                                                return (
                                                    <td style={{ textAlign: "center" }} key={i} className={this.state.records.actualRow[0][field] !== reportData[field] ? "highlighted" : ""} >{this.state.records.actualRow[0][field]}</td>

                                                );
                                            })}

                                            {this.state.records.actualRow.length > 0 ? (<td>{this.state.records.actualRow[0].timestamp}</td>) : null}

                                        </tr>
                                    </tbody>
                                </table>
                                <br />
                                <br />
                                <br />

                                <p style={{ marginBottom: "5px", color: "#0069ff", fontSize: "1.1em" }}>Modification Requests:</p>
                                <table className="simple">
                                    <thead>
                                        <tr>
                                            {this.state.fields.map((column, i) => {
                                                return (<th key={i}>{column.replace(/([A-Z])/g, " $1").replace(/^./, function (str) { return str.toUpperCase(); })}</th>);
                                            })}

                                            <th>Comment</th>
                                            <th>user</th>
                                            <th>Time Stamp</th>
                                            <th>accept</th>
                                            <th>reject</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {this.state.records.permissionRows.length > 0 ?
                                            this.state.records.permissionRows.map((permission, i) => {
                                                // let reportData = JSON.parse(permission.reportData);
                                                return (
                                                    <tr key={i}>
                                                        {this.state.fields.map((field, z) => {
                                                            return (
                                                                <td style={{ textAlign: "center" }} key={i} className={this.state.records.actualRow[0][field] !== reportData[field] ? "highlighted" : ""} key={z}>{reportData[field]}</td>
                                                            );
                                                        })}

                                                        <td>{permission.comment}</td>
                                                        <td>{permission.userName}</td>
                                                        <td>{permission.timestamp}</td>
                                                        <td style={{ textAlign: "center" }}>
                                                            <i className="fa fa-check " aria-hidden="true" onClick={this.onAccept.bind(this, permission, i)} style={{ fontSize: "1.5em", cursor: "pointer", color: "green" }}></i>
                                                        </td>
                                                        <td style={{ textAlign: "center" }}>
                                                            <i className="fa fa-times" aria-hidden="true" onClick={this.onReject.bind(this, permission.notificationId, i)} style={{ fontSize: "1.5em", color: "red", cursor: "pointer" }}></i>
                                                        </td>

                                                    </tr>
                                                );
                                            })
                                            : null}
                                    </tbody>

                                </table>
                            </div> : null}
                        {/*...................deleted block....................*/}
                        {this.state.records.permissionRows.length > 0 && this.state.records.permissionRows[0].permission === 1 ?
                            <div>
                                <p style={{ marginBottom: "5px", color: "#0069ff", fontSize: "1.1em" }}>Current Data:</p>
                                <table className="simple">
                                    <thead>
                                        <tr>
                                            {this.state.fields.map((column, i) => {
                                                return (<th key={i}>{column.replace(/([A-Z])/g, " $1").replace(/^./, function (str) { return str.toUpperCase(); })}</th>);
                                            })}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            {this.state.fields.map((field, i) => {
                                                return (
                                                    <td key={i} >{this.state.records.actualRow[0][field]}</td>
                                                );
                                            })}
                                        </tr>
                                    </tbody>
                                </table>


                                <br />
                                <br />
                                <br />

                                <p style={{ marginBottom: "5px", color: "#0069ff", fontSize: "1.1em" }}>Delete Requests:</p>
                                <table className="simple">
                                    <thead>
                                        <tr>
                                            <th>Comment</th>
                                            <th>user</th>
                                            <th>Time Stamp</th>
                                            <th>accept</th>
                                            <th>reject</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {this.state.records.permissionRows.length > 0 ?
                                            this.state.records.permissionRows.map((permission, i) => {

                                                return (
                                                    <tr key={i}>
                                                        <td>{permission.comment}</td>
                                                        <td>{permission.userName}</td>
                                                        <td>{permission.timestamp}</td>
                                                        <td style={{ textAlign: "center" }}>
                                                            <i className="fa fa-check " aria-hidden="true" onClick={this.onAccept.bind(this, permission, i)} style={{ fontSize: "1.5em", cursor: "pointer", color: "green" }}></i>
                                                        </td>
                                                        <td style={{ textAlign: "center" }}>
                                                            <i className="fa fa-times" aria-hidden="true" onClick={this.onReject.bind(this, permission.notificationId, i)} style={{ fontSize: "1.5em", color: "red", cursor: "pointer" }}></i>
                                                        </td>

                                                    </tr>
                                                );
                                            })
                                            : null}
                                    </tbody>

                                </table>
                            </div>
                            : null}
                    </div> : null
                }

            </div>

        );
    }

}


// WEBPACK FOOTER //
// ./src/jsx/components/pages/permission.jsx